import React, { useEffect, useState } from "react";
import { FaCalendarDays } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { get_active_doctors } from "../../store/reducers/homeReducer";
import DoctorFilter from "./DoctorFilter";

const AllDoctors = () => {
  const dispatch = useDispatch();
  const doctors = useSelector((state) => state.home.doctors);
  const { specialties } = useSelector((state) => state.home);

  const [filteredDoctors, setFilteredDoctors] = useState([]);

  useEffect(() => {
    dispatch(get_active_doctors());
  }, [dispatch]);

  useEffect(() => {
    setFilteredDoctors(doctors);
  }, [doctors]);

  return (
    <div className="w-[85%] sm:w-[92%] flex flex-wrap mx-auto">
      <DoctorFilter
        doctors={doctors}
        specialties={specialties}
        onFilter={setFilteredDoctors}
      />

      <div className="w-full grid grid-cols-4 md-lg:grid-cols-3 md:grid-cols-2  gap-6 sm:gap-3">
        {filteredDoctors &&
          filteredDoctors.map((d, i) => (
            <div
              key={i}
              className="border border-mainColor rounded-2xl sm:rounded-lg group transition-all duration-500 hover:shadow-md hover:-mt-3"
            >
              <Link to={`/doctor/${d._id}`}>
                <div className="relative flex overflow-hidden justify-center ">
                  <img
                    className="sm:w-full w-full h-[220px] sm:h-[150px] rounded-t-2xl sm:rounded-t-lg object-cover object-center"
                    src={d.image}
                    alt={d.name}
                  />
                  <ul className="flex px-1 bg-mainBg/35 backdrop-blur-sm w-full rounded-t-md hover:rounded-md transition-all duration-700 bottom-0 justify-center items-center gap-2 absolute  group-hover:bottom-3">
                    <Link
                      to={`/doctor/${d._id}`}
                      className="w-full h-[38px] cursor-pointe flex justify-center items-center rounded-md hover:bg-mainColor hover:text-white transition-all "
                    >
                      <h2 className="text-lg sm:text-sm font-semibold">
                        {d.name}
                      </h2>
                      <FaCalendarDays className="w-[38px] hover:scale-[1.3] transition-all" />
                    </Link>
                  </ul>
                </div>
                <div className="py-3 text-slate-600 px-5 sm:px-1">
                  <div className="flex flex-wrap justify-between text-md sm:text-xs font-semibold">
                    <h2 className=" ">{d.speciality.replace(/-/g, " ")}</h2>
                    <span className="  text-[#00b8fb]">
                      #{d.businessInfo?.businessName}
                    </span>
                  </div>

                  <p className="text-sm sm:text-xs text-gray-500 mt-2">
                    {d.businessInfo?.description &&
                      (d.businessInfo?.description.length > 70
                        ? `${d.businessInfo?.description.substring(0, 70)}...`
                        : d.businessInfo?.description)}
                  </p>

                  <div className="flex justify-between items-center mt-3 text-sm sm:text-xs">
                    <span className=" font-semibold">
                      {d.businessInfo?.country}, {d.businessInfo?.wilaya}
                    </span>
                    <span className="text-gray-400">
                      Depuis {d.experience} ans
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
      </div>
    </div>
  );
};

export default AllDoctors;
